import { selfCheckInRoute } from 'src/apis';

export const paymentIssuers = `${selfCheckInRoute}/payments/issuers`;
export const paymentSurcharge = `${selfCheckInRoute}/payments/surcharges`;
export const payment = `${selfCheckInRoute}/payments`;
export const postPaymentGenerator = (paymentId: string) =>
    `${payment}/${paymentId}`;
export const getPaymentStatusGenerator = (paymentId: string) =>
    `${payment}/${paymentId}/status`;
